export const GA_CATEGORY_SIDE_BAR_NAV = 'Side Bar Navigation';
export const GA_CATEGORY_BUTTON_NAV = 'BUTTON Navigation';
export const GA_CATEGORY_PRODUCT_SELECT = 'Product Select';
export const GA_CATEGORY_MODEL = 'Model';
export const GA_CATEGORY_WIZARD_STEP = 'Wizard Step';

export const GA_DOC_DOWNLOAD = 'Doc Download';
export const GA_MAIL_TO = 'Mailto';
export const GA_CHECKLIST = 'Checklist';
export const GA_CHECKLIST_SHELF = 'Checklist Shelf';
export const GA_MODEL_SELECTOR = 'Model Selector';
export const GA_FIELD_SELECTOR = 'Field Selector';

// https://developer.mozilla.org/en-US/docs/Web/Events
export const GA_ACTION_CLICKED = 'Click';
export const GA_ACTION_CHECKED = 'Checked';
export const GA_ACTION_UNCHECKED = 'Unchecked';
export const GA_ACTION_OPEN = 'Open';
export const GA_ACTION_CLOSE = 'Close';
export const GA_ACTION_CHANGE = 'Change';
export const GA_ACTION_CHOOSE = 'Choose';

export const GA_LABEL_CONTINUE = 'Continue';
export const GA_LABEL_BACK = 'Back';
export const DOC_EXT_LIST = [
  'csv',
  'doc',
  'docx',
  'pdf',
  'ppt',
  'pptx',
  'xls',
  'xlsx',
  'zip',
  'jpg',
  'jpeg',
  'png',
  'html',
];
